<template lang="pug">
    .wrapper
        LibraryGrid
            .view-explanation
                h1 Interaction Types
                div(
                    v-for="interactionType in interactionTypes"
                )
                    h2 {{interactionType.name}}
                    p(
                        v-if="!interactionType.props || !interactionType.props.length"
                    ) No properties.
                    div.type-container(
                        v-if="interactionType.props.length"
                    )
                        div(
                            v-for="prop in interactionType.props"
                        )
                            h3 Property: {{prop.key}}
                            table
                                thead
                                    tr
                                        th Operators
                                        th Comparands
                                tr
                                    td(
                                        valign="top"
                                    )
                                        p(
                                            v-for="operator in prop.operators"
                                        ) {{ operator }}
                                    td(
                                        valign="top"
                                    )
                                        p(
                                            v-if="prop.key !== 'Contact Country'"
                                            v-for="comparand in prop.comparands"
                                        ) {{ comparand }}
                                        p(v-if="prop.key === 'Contact Country'") (List of countries)
                                        p(
                                            v-if="!prop.comparands || !prop.comparands.length"
                                        ) (User input)

</template>

<script>
import LibraryGrid from '../general/LibraryGrid';
import { getResource } from '../../services/Utils';
export default {
  name: 'InteractionTypes',
  components: {
      LibraryGrid
  },
  data() {
    return {
        interactionTypes: []
    };
  },
  mounted() {
      getResource(`/v1/policies/interaction-types`)
        .then((res) => {
            this.interactionTypes = res.types;
        })
        .catch(error => {
            console.log(error);
        })
  }
};
</script>
<style lang="scss">

table, th, td {
  border: 1px solid #555;
}

table {
    width: 100%;
    max-width: 100%;

    @media all and(min-width: 800px) {
        width: 540px;
    }
}

td {
    padding: 1rem 2rem;
    width: 50%;
}

.type-container {
    padding-bottom: 3rem;
    border-bottom: 1px solid #555;
    margin-bottom: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/views/InteractionTypes.vue